import pin from "./pin.svg";

export default function PinIcon() {
  return (
    <img src={pin} />
  );
}